<template>
  <div>
    <v-row class="ma-0 pr-4 bg-color-1 rounded-lg cell-drag-handle cursor-move">
      <v-col cols="12" class="d-flex pa-0 ma-0">
        <div
          class="d-flex items-center justify-center w-7 rounded-l-lg mr-2 text-white"
          :class="[card.isDupplicate || card.isOverMass ? 'bg-red-700' : 'bg-color-2']"
        >
          {{ ordered }}
        </div>
        <v-autocomplete
          v-model="card.medicineId"
          @change="onCheckMedicine"
          :items="medicineList"
          :disabled="disabled"
          :rules="[rules.required]"
          :error="card.isDupplicate || card.isOverMass"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details
          :background-color="backgroundColor"
          color="blue-grey"
          label=""
          class="mr-1 mt-1 pt-0.5"
          no-data-text="Không có dữ liệu"
        />
        <v-text-field
          v-model="card.mass"
          :rules="[rules.required]"
          :ref="card.id"
          :disabled="disabled"
          :error="card.isOverMass"
          @input="checkMass"
          @keydown="onKeyDown"
          dense
          outlined
          hide-details
          :background-color="backgroundColor"
          type="number"
          hide-spin-buttons
          color="blue-grey"
          class="mt-1 mr-2 w-16 min-w-64/16"
        />
        <v-text-field
          :value="objectMedicine.unitName"
          disabled
          outlined
          hide-details
          dense
          class="mt-1 mr-2 min-w-64/16 w-16"
        />
        <v-icon
          v-if="isShowCheckbox"
          :disabled="disabled"
          medium
          class="cursor-pointer"
          tabindex="-1"
          @click="onHiddenElement"
        >
          {{ iconHidden }}
        </v-icon>
        <v-icon
          v-if="isShowDeletedIcon"
          medium
          class="cursor-pointer"
          tabindex="-1"
          @click="onMinusElement"
        >
          mdi-delete-forever
        </v-icon>
        <div class="inline-block h-12 pt-0.5"></div>
      </v-col>
    </v-row>
    <div v-show="errorMessage" class="mt-1 text-xs" v-html="errorMessage"></div>
  </div>
</template>

<script>
import { required } from "~/utils/validation";
import { debounce } from "~/utils";

export default {
  name: "CardMedicine",
  props: {
    card: {
      type: Object,
      default: () => ({
        medicineId: null,
        mass: null,
        isHidden: false,
        isDupplicate: false,
        isOverMass: false,
      }),
    },
    ordered: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isShowDeletedIcon: {
      type: Boolean,
      default: true,
    },
    isShowCheckbox: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    isValidated: {
      type: Boolean,
      default: true,
    },
    medicineList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      rules: {
        required,
      },
      checkMass: debounce(this.onCheckMedicine, 200),
      isToxic: false,
    };
  },

  created() {
    this.onCheckMedicine();
  },

  computed: {
    backgroundColor() {
      return this.disabled ? "#E4E4E4" : "white";
    },
    iconHidden() {
      return this.card.isHidden ? "mdi-eye-off" : "mdi-eye";
    },
    errorMessage() {
      let errorMessage = "";
      if (this.card.isDupplicate) {
        errorMessage += "<span class='text-red-500'>Trùng vị thuốc </span>";
      }
      if (this.card.isOverMass) {
        errorMessage += "<span class='text-red-500'>Không đủ tồn kho </span>";
      }
      if (this.isToxic) {
        errorMessage += "<span class='warning--text'>Vượt ngưỡng độc </span>";
      }
      return errorMessage;
    },
    objectMedicine() {
      return (
        this.medicineList.find((element) => element.id === this.card.medicineId) || {
          unitName: "gram",
          gramMakeToxic: null,
          isToxic: false,
        }
      );
    },
  },

  methods: {
    onKeyDown(e) {
      if (e.keyCode === 13 && this.card?.medicineId && this.card?.mass) {
        this.$emit("enter");
      }
    },
    onMinusElement() {
      this.$emit("remove");
    },
    onHiddenElement() {
      this.card.isHidden = !this.card.isHidden;
    },
    onCheckMedicine() {
      this.$emit("check:duplicate");
      if (this.isValidated) {
        if (
          this.objectMedicine?.isToxic &&
          this.card.mass >= this.objectMedicine.gramMakeToxic
        ) {
          this.isToxic = true;
        } else {
          this.isToxic = false;
        }
        if (this.card.medicineId && this.card.mass) {
          this.$emit("check:mass");
        }
      }
    },
  },
};
</script>
